var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeviceIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6667 1.41666H11.3333C8.98168 1.41666 7.08334 3.31499 7.08334 5.66666V28.3333C7.08334 30.685 8.98168 32.5833 11.3333 32.5833H22.6667C25.0183 32.5833 26.9167 30.685 26.9167 28.3333V5.66666C26.9167 3.31499 25.0183 1.41666 22.6667 1.41666ZM24.0833 25.5H9.91668V5.66666H24.0833V25.5ZM14.1667 29.75H19.8333V28.3333H14.1667V29.75Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceIcon);
export default __webpack_public_path__ + "static/media/device-icon.c983dee7784964d4a26ef2375d3dc55e.svg";
export { ForwardRef as ReactComponent };